import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Assuming you're using axios

function IssueReportForm({ farmId, imageId, user, onClose, onSuccess }) {
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // API endpoint for your Lambda function
  const API_URL = process.env.REACT_APP_API_URL;

  // Function to submit the issue report
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!description.trim()) {
      setError('Please provide a description of the issue');
      return;
    }
    
    setSubmitting(true);
    setError(null);
    
    try {
      // Log the data being sent for debugging
      console.log('Sending issue report:', {
        farmId, 
        imageId, 
        description, 
        user
      });
      
      // Send the issue report to your Lambda function
      const response = await axios.post(`${API_URL}/issue`, {
        farmId,
        imageId,
        description,
        user
      });
      
      console.log('Issue report response:', response.data);
      
      if (response.data.success) {
        onSuccess();
      } else if (response.data.error) {
        throw new Error(response.data.error);
      }
    } catch (err) {
      console.error('Error submitting issue:', err);
      setError('Failed to submit issue. Please try again or contact dispatch directly.');
    } finally {
      setSubmitting(false);
    }
  };

  // Handle ESC key to close the modal
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    
    // Focus the textarea when the form appears
    const textarea = document.getElementById('issue-description');
    if (textarea) {
      textarea.focus();
    }
    
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  // Handle clicks outside the modal to close it
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999]"
      onClick={handleBackdropClick}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-bold mb-4">Report Issue</h3>
        
        <form onSubmit={handleSubmit}>
          <p>Please describe the issue</p>
          
          <textarea
            id="issue-description"
            className="w-full border rounded mt-2 p-2 h-32"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe the issue with this image..."
            disabled={submitting}
          ></textarea>
          
          {error && (
            <p className="text-red-600 mt-2">{error}</p>
          )}
          
          <div className="flex justify-end mt-4">
            <button
              type="button"
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded mr-2"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default IssueReportForm;